module.exports = __webpack_public_path__ + "img/evaluate-icon.79ec30c1.png";